<template>
  <div class="con">
   <div class="txt" v-html="info.content">
     <p>
       一则好的文案，几乎决定了广告营销必将走向成功之路。其实，广告文案是有规则可循的。广告文案大师约瑟夫·休格曼曾说过这样一句话：复杂的产品要简单说明，简单的产品要复杂说明。今天，菲力克影视同大家简单分享一些关于这两句话的理解。为什么是对立的层面？这其实取决于消费者对于产品的认知和心理感触。
     </p>
   </div>
  </div>

</template>

<script>
export default {
  name: 'ruleDetaile',
  data () {
    return {
      type:'',
      info:{},// 详情
    }
  },
  mounted(){
    if(this.getUrlParamURLys("type")){
      this.type=this.getUrlParamURLys("type");
      this.getinfo();
    }

  },
  methods:{
    getinfo:function () {
      var _this=this;
      _this.call_net("POST","/api/app/singlepage/info",{type:_this.type},function (data) {
        if(data.code===200){
          _this.info=data.data;
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con{
    padding: 0.3rem;
    padding-top:0.4rem;
  }
  .txt >>> p,.txt >>> span,.txt{
    font-size: 0.28rem !important;
    color: #666 !important;
    line-height: 0.5rem;
    font-family: "微软雅黑" !important;
    font-style: normal !important;
  }
  .txt>>>img{
    display: block;
    width: 100%;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/detaile.vue